import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/users')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/users/${id}`)
    return data
  },

  async create(employeeData) {
    const formData = new FormData()
    
    // Append all fields to FormData
    Object.keys(employeeData).forEach(key => {
      if (employeeData[key] !== null && employeeData[key] !== undefined) {
        if (key === 'roles_ids' && Array.isArray(employeeData[key])) {
          // Append array items with index notation
          employeeData[key].forEach((roleId, index) => {
            formData.append(`roles_ids[${index}]`, roleId)
          })
        } else if (key === 'img' && employeeData[key] instanceof File) {
          // Append file
          formData.append('img', employeeData[key])
        } else {
          formData.append(key, employeeData[key])
        }
      }
    })

    const { data } = await api.post('/admin/users', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data
  },

  async update(id, employeeData) {
    const formData = new FormData()
    
    // Add _method for Laravel to recognize PUT request
    formData.append('_method', 'PUT')
    
    // Append all fields to FormData
    Object.keys(employeeData).forEach(key => {
      if (employeeData[key] !== null && employeeData[key] !== undefined) {
        if (key === 'roles_ids' && Array.isArray(employeeData[key])) {
          employeeData[key].forEach((roleId, index) => {
            formData.append(`roles_ids[${index}]`, roleId)
          })
        } else if (key === 'img' && employeeData[key] instanceof File) {
          formData.append('img', employeeData[key])
        } else {
          formData.append(key, employeeData[key])
        }
      }
    })

    const { data } = await api.post(`/admin/users/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/users/${id}`)
    return data
  }
}
